var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.5,
    r: 11,
    fill: "#FF8000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5903 20.3682V13.5H16.4097V20.3682H17.5903ZM16.3208 22.1899C16.3208 22.3804 16.3779 22.5412 16.4922 22.6724C16.6107 22.8035 16.7842 22.8691 17.0127 22.8691C17.237 22.8691 17.4084 22.8035 17.5269 22.6724C17.6496 22.5412 17.7109 22.3804 17.7109 22.1899C17.7109 22.008 17.6496 21.8514 17.5269 21.7202C17.4084 21.5933 17.237 21.5298 17.0127 21.5298C16.7842 21.5298 16.6107 21.5933 16.4922 21.7202C16.3779 21.8514 16.3208 22.008 16.3208 22.1899Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.bb47490b3029d13214b59398a9ca74ca.svg";
export { ForwardRef as ReactComponent };